"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TabPaneList = exports.TabPane = exports.TabNavList = exports.TabNav = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var TabsContext = /*#__PURE__*/(0, _react.createContext)(undefined);
var ForwardTabs = /*#__PURE__*/(0, _react.forwardRef)(function (_a, ref) {
  var children = _a.children,
      defaultActiveTab = _a.defaultActiveTab,
      className = _a.className;

  var _b = (0, _react.useState)(defaultActiveTab !== null && defaultActiveTab !== void 0 ? defaultActiveTab : ''),
      activeIndex = _b[0],
      setActiveIndex = _b[1];

  return /*#__PURE__*/_react["default"].createElement(TabsContext.Provider, {
    value: {
      activeIndex: activeIndex,
      setActiveIndex: setActiveIndex
    }
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: (0, _classnames["default"])('TCI-Tabs', className),
    ref: ref
  }, children));
});
var TabNavList = /*#__PURE__*/(0, _react.forwardRef)(function (_a, ref) {
  var className = _a.className,
      children = _a.children,
      restProps = __rest(_a, ["className", "children"]);

  return /*#__PURE__*/_react["default"].createElement("nav", __assign({
    className: (0, _classnames["default"])('TCI-TabNavList', className),
    ref: ref
  }, restProps), children);
});
exports.TabNavList = TabNavList;
var TabPaneList = /*#__PURE__*/(0, _react.forwardRef)(function (_a, ref) {
  var className = _a.className,
      children = _a.children,
      restProps = __rest(_a, ["className", "children"]);

  return /*#__PURE__*/_react["default"].createElement("article", __assign({
    className: (0, _classnames["default"])('TCI-TabPaneList', className),
    ref: ref
  }, restProps), children);
});
exports.TabPaneList = TabPaneList;
var TabNav = /*#__PURE__*/(0, _react.forwardRef)(function (_a, ref) {
  var children = _a.children,
      index = _a.index,
      className = _a.className,
      restProps = __rest(_a, ["children", "index", "className"]);

  var tabsContext = (0, _react.useContext)(TabsContext);
  return /*#__PURE__*/_react["default"].createElement("button", __assign({
    ref: ref,
    className: (0, _classnames["default"])('TCI-TabNav', className, {
      active: tabsContext.activeIndex === index
    }),
    onClick: function onClick() {
      return tabsContext === null || tabsContext === void 0 ? void 0 : tabsContext.setActiveIndex(index);
    }
  }, restProps), children);
});
exports.TabNav = TabNav;
var TabPane = /*#__PURE__*/(0, _react.forwardRef)(function (_a, ref) {
  var children = _a.children,
      index = _a.index,
      className = _a.className,
      restProps = __rest(_a, ["children", "index", "className"]);

  var tabsContext = (0, _react.useContext)(TabsContext);
  return /*#__PURE__*/_react["default"].createElement("section", __assign({
    className: (0, _classnames["default"])('TCI-TabPane', {
      active: tabsContext.activeIndex === index
    }),
    ref: ref
  }, restProps), children);
});
exports.TabPane = TabPane;
ForwardTabs.displayName = 'TCI-Tabs';
TabNavList.displayName = 'TCI-TabNavList';
TabNav.displayName = 'TCI-TabNav';
TabPane.displayName = 'TCI-TabPane';
TabPaneList.displayName = 'TCI-TabPaneList';
ForwardTabs.TabNavList = TabNavList;
ForwardTabs.TabPaneList = TabPaneList;
ForwardTabs.TabNav = TabNav;
ForwardTabs.TabPane = TabPane;
var _default = ForwardTabs;
exports["default"] = _default;